export const fr = {
  properties: {
    title: 'Propriétés',
    position: 'Position',
    x: 'Position X',
    y: 'Position Y',
    rotation: 'Rotation',
    color: 'Couleur',
    number: 'Numéro',
    name: 'Nom',
    team: 'Équipe',
    otherNumber: 'Autre numéro...',
    size: {
      title: 'Taille',
      small: 'Petit',
      medium: 'Moyen',
      large: 'Grand'
    },
    visibility: {
      show: 'Afficher',
      hide: 'Masquer',
      toggleAll: 'Tous'
    },
    actions: {
      applyToAll: 'Appliquer à tous',
      delete: 'Supprimer',
      lockPosition: 'Verrouiller la position'
    }
  },
  toolbar: {
    newPage: 'Nouvelle page',
    open: 'Charger',
    save: 'Sauvegarder',
    addPlayer: 'Ajouter un joueur',
    addBall: 'Ajouter un ballon',
    addZone: 'Ajouter une zone',
    addArrow: 'Ajouter une flèche',
    editField: 'Modifier le terrain',
    exportVideo: 'Exporter en vidéo',
    exportImage: 'Exporter en PNG',
    backgroundColor: 'Couleur du fond',
    changeLanguage: 'Changer de langue',
    login: 'Se connecter',
    logout: 'Se déconnecter',
    fullscreen: 'Plein écran'
  },
  mobile: {
    rotateDevice: 'Veuillez tourner votre téléphone en mode paysage'
  },
  panels: {
    pitch: {
      title: 'Configuration du terrain',
      type: {
        title: 'Type de terrain',
        label: 'Type de terrain',
        full: 'Terrain complet (11v11)',
        half: 'Demi-terrain'
      },
      side: {
        label: 'Côté du terrain',
        left: 'Gauche',
        right: 'Droite'
      },
      display: {
        title: 'Affichage',
        medianLine: 'Ligne médiane',
        centralCircle: 'Rond central',
        centralPoint: 'Point central',
        penaltyArea: 'Surface de réparation',
        penaltyAreaArcs: 'Arcs de surface',
        penaltyPoints: 'Points de penalty',
        goalArea: 'Surface de but',
        goals: 'Buts',
        cornerArcs: 'Arcs de corner',
        halfSpaces: 'Demi-espaces',
        rotate: 'Rotation 90° (terrain plus large)'
      }
    },
    zone: {
      title: 'Zone',
      opacity: 'Opacité',
      fill: 'Couleur de remplissage',
      borderStyle: 'Style de bordure',
      strokeWidth: 'Épaisseur de bordure',
      strokeOpacity: 'Opacité de bordure',
      draggable: 'Déplaçable',
      lock: 'Verrouiller la zone',
      strokeColor: 'Couleur du trait',
      fillColor: 'Couleur de remplissage',
      fillOpacity: 'Opacité du remplissage',
      dashArray: 'Style de ligne',
      solid: 'Pleine',
      dashed: 'Pointillée',
      dotted: 'Points',
      lockPosition: 'Verrouiller la position',
      delete: 'Supprimer la zone'
    },
    player: {
      title: 'Joueur'
    },
    ball: {
      title: 'Ballon',
      size: 'Taille',
      color: 'Couleur',
      strokeColor: 'Couleur contour',
      hideStroke: 'Masquer le contour'
    },
    arrow: {
      title: 'Flèche',
      strokeWidth: 'Épaisseur du trait',
      strokeOpacity: 'Opacité du trait',
      borderStyle: 'Style de trait',
      color: 'Couleur',
      styles: {
        solid: 'Continu',
        dashed: 'Tirets',
        dotted: 'Pointillés'
      }
    },
    trainingItem: {
      title: 'Modifier',
      color: 'Couleur',
      size: 'Taille',
      rotation: 'Rotation',
      fineRotation: 'Rotation précise'
    },
    training: {
      title: 'Matériel',
      items: {
        cone: 'Cône',
        mannequin: 'Mannequin',
        goal: 'But',
        ladder: 'Échelle',
        hoop: 'Cerceau',
        disc: 'Coupelle',
        hurdle: 'Haie',
        pole: 'Bâton',
        miniGoal: 'Mini-but',
        one: 'Étape 1',
        two: 'Étape 2',
        three: 'Étape 3',
        four: 'Étape 4',
        five: 'Étape 5'
      }
    }
  },
  landing: {
    hero: {
      title: {
        part1: "L'outil le plus simple",
        part2: "et rapide",
        part3: "pour générer des vidéos de"
      },
      words: {
        videos: "RONDOS",
        sequences: "SÉQUENCES",
        compositions: "COMPOSITIONS",
        exercises: "EXERCICES",
        cpa: "CPA",
        games: "JEUX"
      },
      cta: "Commencer gratuitement",
      login: "Se connecter"
    },
    sections: {
      video: {
        title: "Voir TacticaFoot en action"
      },
      exercises: {
        title: "Créez vos exercices",
        cta: "Découvrir"
      },
      sessions: {
        title: "Organisez vos séances",
        cta: "En savoir plus"
      },
      present: {
        title: "Présentez",
        cta: "Essayer maintenant"
      },
      share: {
        title: "Partagez",
        cta: "Rejoindre",
        login: "Se connecter"
      },
      pricing: {
        title: "Nos Tarifs",
        regularPrice: "65€ / an",
        specialOffer: "Offre Spéciale",
        specialPrice: "37€ / an",
        payButton: "M'abonner"
      },
      why: {
        title: 'Pourquoi TACTICAFOOT',
        features: {
          simple: {
            title: 'Simple',
            description: 'TacticaFoot est si simple que vous savez déjà l\'utiliser'
          },
          sync: {
            title: 'Synchronisé',
            description: 'Accédez à vos tactiques sur tous vos appareils'
          },
          rapide: {
            title: 'Rapide',
            description: 'L\'app la plus rapide pour générer des vidéos ou des images'
          },
          puissant: {
            title: 'Puissant',
            description: 'Dotez votre équipe de super pouvoirs'
          },
          accessible: {
            title: 'Accessible',
            description: 'TacticaFoot est disponible partout, sans aucune installation'
          },
          secure: {
            title: 'Sécurisé',
            description: 'Vos données sont protégées et sauvegardées'
          },
          intuitif: {
            title: 'Intuitif',
            description: 'Une interface fluide et pensée pour les entraîneurs'
          },
          evolutif: {
            title: 'Évolutif',
            description: 'Des améliorations toutes les semaines'
          },
          collab: {
            title: 'Collaboratif',
            description: 'Envoyez les vidéos et images à vos équipes ou staff'
          }
        }
      }
    },
    nav: {
      discover: 'Découvrir',
      pricing: 'Tarifs',
      contact: 'Contact'
    }
  },
  footer: {
    rights: 'Tous droits réservés',
    contact: 'Contact',
    legal: 'Mentions légales',
    otherTools: {
      title: 'Autres outils',
      features: 'Gestion d\'équipe, Bibliothèque d\'exercices, Gestion des matchs et entrainements, Convocations, Présences'
    }
  },
  signup: {
    title: {
      step1: 'Créer un compte',
      step2: 'Finaliser l\'inscription'
    },
    fields: {
      email: 'Email',
      firstName: 'Prénom',
      lastName: 'Nom',
      club: 'Club',
      phone: 'Téléphone',
      password: 'Mot de passe',
      marketingSource: 'Comment nous avez-vous connu ?'
    },
    country: 'Pays',
    language: 'Langue',
    buttons: {
      validate: 'Valider',
      signup: 'S\'inscrire'
    },
    consent: 'J\'accepte de recevoir les nouveautés de Tacticafoot.',
    success: {
      title: 'Inscription réussie !',
      message: 'Un email de confirmation vous a été envoyé. Veuillez vérifier votre boîte de réception.',
      cta: 'Accéder au tutoriel'
    },
    errors: {
      required: 'Ce champ est obligatoire',
      consent: 'Vous devez accepter de recevoir les nouveautés',
      emailInUse: 'Un compte existe déjà avec cette adresse email.',
      registration: 'Erreur lors de l\'inscription'
    }
  },
  login: {
    title: 'Connexion',
    fields: {
      email: 'Email',
      password: 'Mot de passe',
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe',
      rememberMe: 'Se souvenir de moi'
    },
    buttons: {
      login: 'Se connecter',
      forgotPassword: 'Mot de passe oublié ?',
      signup: 'Créer un compte'
    },
    errors: {
      invalidEmail: 'Adresse email invalide',
      userDisabled: 'Ce compte a été désactivé',
      userNotFound: 'Aucun compte ne correspond à cette adresse email',
      wrongPassword: 'Mot de passe incorrect',
      default: 'Une erreur est survenue lors de la connexion'
    },
    resetPassword: {
      title: 'Réinitialiser le mot de passe',
      description: 'Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
      button: 'Envoyer le lien',
      cancel: 'Annuler',
      success: 'Email envoyé ! Vérifiez votre boîte de réception.',
      error: 'Erreur lors de l\'envoi de l\'email. Vérifiez votre adresse email.'
    }
  }
};
